import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { Question } from '../../types';

interface Props {
  question: Question;
}

export const DescriptionQuestion: React.FC<Props> = ({ question }) => {
  // If there's no text, return null to hide the component
  if (!question.text || question.text.trim() === '') {
    return null;
  }

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        mb: 3
      }}
    >
      <Box>
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.primary',
            whiteSpace: 'pre-line',  // Preserve line breaks
            mb: 2
          }}
        >
          {question.text}
        </Typography>
      </Box>
    </Paper>
  );
};
